//
// Copy to Clipboard
// ---------------------------------------------------------------------------

'use strict';

const config = {
    triggerSelector: '.js-copy-to-clipboard'
};

if (document.queryCommandSupported('copy')) {
    $(config.triggerSelector).click(function(event) {
        event.preventDefault();

        try {
            let copyTarget = document.getElementById($(this).data('targetId'));
            copyTarget.focus();
            copyTarget.select();
            document.execCommand('copy');
        } catch (err) {
            // want to let the user know that copying to clipboard didn't work
            alert(err);
        }
    });
} else {
    // don't show 'copy' buttons if copy command not supported
    $(config.triggerSelector).attr('display', 'none');
}



// WEBPACK FOOTER //
// ./src/js/components/copy-to-clipboard.js